import React from 'react'

const ProgressTracker = () => {
	return (
		<div className="mx-4 flex max-w-[848px] flex-col items-center rounded-2xl bg-white shadow-custom">
			<h3 className="my-8 px-4 text-center text-xl font-bold">
				V červnu stihneme{' '}
				<span className=" text-primary">poslední 2 implementace</span>
			</h3>
			{/* desktop */}
			<div className="mx-16 mb-8 hidden gap-2 lg:flex">
				{Array.from({ length: 17 }, (index: number) => (
					<img
						key={index}
						src="img/icons/progress-rectangle-blue.svg"
						alt="rectangle"
						width={30}
						height={43}
					/>
				))}
				{Array.from({ length: 3 }, (index: number) => (
					<img
						key={index}
						src="img/icons/progress-rectangle-orange.svg"
						alt="rectangle"
						width={30}
						height={43}
					/>
				))}
			</div>
			{/* mobile */}
			<div className="mb-8 block lg:hidden">
				<img src="img/icons/progress-mobile.svg" alt="progress" />
			</div>
		</div>
	)
}

export default ProgressTracker
